<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-25 14:57:58
 * @LastEditors: guozhixion xiaoguo4072@163.com
 * @LastEditTime: 2022-05-30 09:48:25
 * @FilePath: /privacy-web/src/components/homePage/PrivacyProtectConceptContentItem.vue
-->
<template>
  <div class="contentItem-main" :class="{ 'contentItem-main-mobile': isMobile }">
    <div class="contentItem-background"></div>
    <video
      ref="privacy-protect-video"
      controls
      preload="none"
      :poster="src.poster"
      class="contentItem-image"
      controlslist="nodownload noplaybackrate"
      :src="src.video"
    ></video>
  </div>
</template>
<script>
export default {
  // 隐私保护视频内容
  name: "PrivacyProtectConceptContentItem",
  props: { src: { type: Object, default: () => {} } },
  mounted() {
    let video = this.$refs["privacy-protect-video"];
    video.addEventListener(
      "ended",
      function () {
        const videoSrc = video.currentSrc;
        video.src = "";
        video.src = videoSrc;
      },
      false
    );
  },
};
</script>
<style lang="scss" scoped>
.contentItem-main {
  position: relative;
  margin-top: calc($multiple * 20px);
  .contentItem-background {
    width: calc($multiple * 1117px);
    height: calc($multiple * 297px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url("../../assets/images/homePage/protect-background.png") 100% no-repeat;
    background-size: cover;
    z-index: 1;
  }
  .contentItem-image {
    position: relative;
    background: #f6faff;
    width: calc($multiple * 831px);
    max-height: calc($multiple * 500px);
    object-fit: cover;
    z-index: 2;
  }
}
.contentItem-main-mobile {
  margin-top: 1.43rem;
  .contentItem-background {
    width: 17.1rem;
    height: 5.48rem;
    background: url("../../assets/images/homePage/protect-background-mobile.png") 100%
      no-repeat;
    background-size: cover;
  }
  .contentItem-image {
    width: 15.24rem;
    max-height: 10rem;
  }
}
</style>
